import {
    Component,
    forwardRef,
    Host,
    OnInit,
    Optional,
    SkipSelf,
} from '@angular/core';

import {ControlContainer, NG_VALUE_ACCESSOR} from '@angular/forms';

import {BehaviorSubject} from 'rxjs';

import {CountryAutocompleteControl} from '../../classes';
import {AutocompleteComponent, AutocompleteOptionInterface} from '../../components';

import {CountryAutocompleteItemInterface} from './interfaces/country-autocomplete-item.interface';

@Component({
    selector: 'app-country-autocomplete',
    templateUrl: './country-autocomplete.component.html',
    styleUrls: ['./country-autocomplete.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CountryAutocompleteComponent),
        multi: true
    }]
})
export class CountryAutocompleteComponent extends AutocompleteComponent implements OnInit {
    private items: CountryAutocompleteItemInterface[];

    constructor(
        @Optional() @Host() @SkipSelf()
        protected controlContainer: ControlContainer
    ) {
        super(controlContainer);
    }

    private createAutocompleteOptions(): AutocompleteOptionInterface[] {
        return this.items.filter((country: CountryAutocompleteItemInterface) => {
            return country.id && country.name;
        }).map((country: CountryAutocompleteItemInterface) => {
            return {
                label: country.name,
                value: country.id,
                classes: this.countryIconClassPrefix + country.id.toLowerCase()
            };
        });
    }

    ngOnInit() {
        this.items = this.asFormsControl().countries;

        this.asFormsControl().options = this.createAutocompleteOptions();

        this.autocompleteOptions = new BehaviorSubject(this.asFormsControl().options);

        this.checkInvalid();
    }

    asFormsControl(): CountryAutocompleteControl {
        if (!this.control || !(this.control instanceof CountryAutocompleteControl)) {
            this.control = new CountryAutocompleteControl({
                name: '',
                value: '',
                placeholder: '',
                validators: [],
                componentType: 0,
                invalid: false,
                errors: [],
                options: [],
                countries: [],
            });
        }

        const control = (this.control as CountryAutocompleteControl);

        if (control.countries.length !== 0) {
            this.items = control.countries
                .sort((current: CountryAutocompleteItemInterface, next: CountryAutocompleteItemInterface) => {
                    if ( current.name.toLowerCase() < next.name.toLowerCase() ) {
                        return -1;
                    } else if ( current.name.toLowerCase() > next.name.toLowerCase() ) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

            control.options = this.createAutocompleteOptions();
        }

        return control;
    }
}
